const PALETTES = [
  { bg1: '#1e3a8a', bg2: '#7c3aed', accent: '#a78bfa' },
  { bg1: '#0f172a', bg2: '#1e40af', accent: '#60a5fa' },
  { bg1: '#312e81', bg2: '#6d28d9', accent: '#c4b5fd' },
  { bg1: '#0c4a6e', bg2: '#0e7490', accent: '#67e8f9' },
  { bg1: '#1e1b4b', bg2: '#4338ca', accent: '#818cf8' },
  { bg1: '#0f172a', bg2: '#581c87', accent: '#d8b4fe' },
  { bg1: '#172554', bg2: '#7e22ce', accent: '#e9d5ff' },
  { bg1: '#020617', bg2: '#1d4ed8', accent: '#93c5fd' },
]

const ICONS: Record<string, string> = {
  book: '📚',
  pastpaper: '📝',
  other: '📁',
}

function wrapText(
  ctx: CanvasRenderingContext2D,
  text: string,
  maxWidth: number,
): string[] {
  const words = text.split(' ')
  const lines: string[] = []
  let current = ''
  words.forEach((word) => {
    const test = current ? current + ' ' + word : word
    if (ctx.measureText(test).width > maxWidth) {
      if (current) lines.push(current)
      current = word
    } else {
      current = test
    }
  })
  if (current) lines.push(current)
  return lines.slice(0, 3)
}

function style1(
  ctx: CanvasRenderingContext2D,
  name: string,
  type: string,
  format: string,
  pal: (typeof PALETTES)[0],
) {
  // Gradient with geometric circles
  const grad = ctx.createLinearGradient(0, 0, 400, 300)
  grad.addColorStop(0, pal.bg1)
  grad.addColorStop(1, pal.bg2)
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, 400, 300)

  ctx.globalAlpha = 0.06
  ctx.fillStyle = '#fff'
  for (let i = 0; i < 8; i++) {
    ctx.beginPath()
    ctx.arc(
      50 + Math.random() * 300,
      30 + Math.random() * 240,
      15 + Math.random() * 30,
      0,
      Math.PI * 2,
    )
    ctx.fill()
  }
  ctx.globalAlpha = 1

  ctx.font = '44px serif'
  ctx.textAlign = 'center'
  ctx.fillText(ICONS[type] || '📄', 200, 90)

  ctx.fillStyle = '#fff'
  ctx.font = 'bold 19px sans-serif'
  const lines = wrapText(ctx, name, 340)
  lines.forEach((l, i) => ctx.fillText(l, 200, 135 + i * 26))

  ctx.fillStyle = pal.accent
  ctx.font = 'bold 12px monospace'
  const bw = ctx.measureText(format).width + 20
  ctx.globalAlpha = 0.3
  ctx.fillStyle = '#fff'
  ctx.beginPath()
  ctx.roundRect(200 - bw / 2, 220, bw, 24, 6)
  ctx.fill()
  ctx.globalAlpha = 1
  ctx.fillStyle = '#fff'
  ctx.fillText(format, 200, 237)

  ctx.fillStyle = 'rgba(0,0,0,0.25)'
  ctx.fillRect(0, 276, 400, 24)
  ctx.fillStyle = 'rgba(255,255,255,0.6)'
  ctx.font = '10px sans-serif'
  ctx.fillText('Theo EduMarket Rwanda', 200, 292)
}

function style2(
  ctx: CanvasRenderingContext2D,
  name: string,
  type: string,
  format: string,
  pal: (typeof PALETTES)[0],
) {
  // Dark with diagonal stripe
  ctx.fillStyle = pal.bg1
  ctx.fillRect(0, 0, 400, 300)

  ctx.fillStyle = pal.bg2
  ctx.beginPath()
  ctx.moveTo(0, 0)
  ctx.lineTo(400, 0)
  ctx.lineTo(400, 150)
  ctx.lineTo(0, 220)
  ctx.closePath()
  ctx.fill()

  ctx.globalAlpha = 0.08
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 1
  for (let i = 0; i < 10; i++) {
    ctx.beginPath()
    ctx.moveTo(-50 + i * 50, 0)
    ctx.lineTo(-50 + i * 50 + 100, 300)
    ctx.stroke()
  }
  ctx.globalAlpha = 1

  ctx.font = '36px serif'
  ctx.textAlign = 'center'
  ctx.fillStyle = '#fff'
  ctx.fillText(ICONS[type] || '📄', 60, 60)

  ctx.fillStyle = '#fff'
  ctx.font = 'bold 20px sans-serif'
  ctx.textAlign = 'left'
  const lines = wrapText(ctx, name, 300)
  lines.forEach((l, i) => ctx.fillText(l, 30, 130 + i * 28))

  ctx.fillStyle = pal.accent
  ctx.font = 'bold 14px monospace'
  ctx.textAlign = 'left'
  ctx.fillText(format, 30, 230)

  ctx.fillStyle = 'rgba(255,255,255,0.5)'
  ctx.font = '10px sans-serif'
  ctx.textAlign = 'right'
  ctx.fillText('Theo EduMarket Rwanda', 380, 285)
}

function style3(
  ctx: CanvasRenderingContext2D,
  name: string,
  type: string,
  format: string,
  pal: (typeof PALETTES)[0],
) {
  // Circular badge design
  ctx.fillStyle = pal.bg1
  ctx.fillRect(0, 0, 400, 300)

  const cgrad = ctx.createRadialGradient(200, 150, 20, 200, 150, 180)
  cgrad.addColorStop(0, pal.bg2)
  cgrad.addColorStop(1, 'transparent')
  ctx.fillStyle = cgrad
  ctx.fillRect(0, 0, 400, 300)

  ctx.strokeStyle = pal.accent
  ctx.lineWidth = 2
  ctx.globalAlpha = 0.3
  ctx.beginPath()
  ctx.arc(200, 140, 90, 0, Math.PI * 2)
  ctx.stroke()
  ctx.beginPath()
  ctx.arc(200, 140, 70, 0, Math.PI * 2)
  ctx.stroke()
  ctx.globalAlpha = 1

  ctx.font = '40px serif'
  ctx.textAlign = 'center'
  ctx.fillStyle = '#fff'
  ctx.fillText(ICONS[type] || '📄', 200, 125)

  ctx.fillStyle = pal.accent
  ctx.font = 'bold 11px monospace'
  ctx.fillText(format, 200, 155)

  ctx.fillStyle = '#fff'
  ctx.font = 'bold 17px sans-serif'
  const lines = wrapText(ctx, name, 340)
  lines.forEach((l, i) => ctx.fillText(l, 200, 210 + i * 24))

  ctx.fillStyle = 'rgba(255,255,255,0.4)'
  ctx.font = '10px sans-serif'
  ctx.fillText('Theo EduMarket Rwanda', 200, 290)
}

function style4(
  ctx: CanvasRenderingContext2D,
  name: string,
  type: string,
  format: string,
  pal: (typeof PALETTES)[0],
) {
  // Minimalist with large format badge
  const grad = ctx.createLinearGradient(0, 0, 0, 300)
  grad.addColorStop(0, pal.bg2)
  grad.addColorStop(1, pal.bg1)
  ctx.fillStyle = grad
  ctx.fillRect(0, 0, 400, 300)

  // Large format text
  ctx.globalAlpha = 0.07
  ctx.fillStyle = '#fff'
  ctx.font = 'bold 120px monospace'
  ctx.textAlign = 'right'
  ctx.fillText(format, 390, 130)
  ctx.globalAlpha = 1

  // Top accent line
  ctx.fillStyle = pal.accent
  ctx.fillRect(0, 0, 400, 3)

  ctx.font = '30px serif'
  ctx.textAlign = 'left'
  ctx.fillStyle = '#fff'
  ctx.fillText(ICONS[type] || '📄', 30, 55)

  ctx.fillStyle = '#fff'
  ctx.font = 'bold 20px sans-serif'
  ctx.textAlign = 'left'
  const lines = wrapText(ctx, name, 340)
  lines.forEach((l, i) => ctx.fillText(l, 30, 160 + i * 28))

  ctx.fillStyle = pal.accent
  ctx.fillRect(30, 240, 60, 3)

  ctx.fillStyle = 'rgba(255,255,255,0.5)'
  ctx.font = '10px sans-serif'
  ctx.fillText('Theo EduMarket Rwanda', 30, 275)
}

function style5(
  ctx: CanvasRenderingContext2D,
  name: string,
  type: string,
  format: string,
  pal: (typeof PALETTES)[0],
) {
  // Split design
  ctx.fillStyle = pal.bg1
  ctx.fillRect(0, 0, 200, 300)
  ctx.fillStyle = pal.bg2
  ctx.fillRect(200, 0, 200, 300)

  // Decorative dots
  ctx.globalAlpha = 0.1
  ctx.fillStyle = '#fff'
  for (let y = 20; y < 300; y += 30) {
    for (let x = 10; x < 190; x += 30) {
      ctx.beginPath()
      ctx.arc(x, y, 3, 0, Math.PI * 2)
      ctx.fill()
    }
  }
  ctx.globalAlpha = 1

  ctx.font = '50px serif'
  ctx.textAlign = 'center'
  ctx.fillStyle = '#fff'
  ctx.fillText(ICONS[type] || '📄', 100, 100)

  ctx.fillStyle = pal.accent
  ctx.font = 'bold 16px monospace'
  ctx.fillText(format, 100, 140)

  ctx.fillStyle = '#fff'
  ctx.font = 'bold 18px sans-serif'
  ctx.textAlign = 'center'
  const lines = wrapText(ctx, name, 170)
  lines.forEach((l, i) => ctx.fillText(l, 300, 100 + i * 26))

  ctx.fillStyle = 'rgba(255,255,255,0.4)'
  ctx.font = '10px sans-serif'
  ctx.fillText('Theo EduMarket Rwanda', 300, 270)
}

export function generateCover(
  name: string,
  type: string,
  format: string,
): string {
  const canvas = document.createElement('canvas')
  canvas.width = 400
  canvas.height = 300
  const ctx = canvas.getContext('2d')!

  const pal = PALETTES[Math.floor(Math.random() * PALETTES.length)]
  const styles = [style1, style2, style3, style4, style5]
  const styleFn = styles[Math.floor(Math.random() * styles.length)]

  styleFn(ctx, name, type, format, pal)

  return canvas.toDataURL('image/png')
}
